import { EventInput } from '@fullcalendar/core';


export function createEventId() {
    let eventGuid = 0;
    return String(eventGuid++);
}

export function generateMonthlyEvents(dayOfMonth: number, title: string) {
    const today = new Date();
    const currentYear = today.getFullYear();
    const events = [];

    for (let month = 0; month < 12; month++) {
      events.push({
        id: createEventId(),
        title: title,
        start: new Date(currentYear, month, dayOfMonth),
        allDay: true
      });
    }

    return events;
}

export function generateRecurringEvent1() {
    const today = new Date();
    const currentYear = today.getFullYear();
    const events = [];

    for (let month = 0; month < 12; month++) {
      events.push({
        id: createEventId(),
        // title: `Event 1 - ${month + 1}`,
        start: new Date(currentYear, month, 10), // 10th day of each month
        color: 'rgba(0, 0, 0, 0.3)',
        display: 'background',
        description: 'This is a cool event',
        allDay: true
      });
    }

    return events;
  }

  export function generateRecurringEvent2() {
    const today = new Date();
    const currentYear = today.getFullYear();
    const events = [];

    for (let month = 0; month < 12; month++) {
      events.push({
        id: createEventId(),
        // title: `Event 2 - ${month + 1}`,
        start: new Date(currentYear, month, 21), // 15th day of each month
        // let this be blue
        color: 'rgba(0, 0, 255, 0.3)',
        display: 'background',
        description: 'This is a cool event',
        allDay: true
      });
    }

    return events;
  }

//  event for last day of every month
export function generateRecurringEvent3() {
    const today = new Date();
    const currentYear = today.getFullYear();
    const events = [];

    for (let month = 0; month < 12; month++) {
        events.push({
            id: createEventId(),
            // title: `Event 3 - ${month + 1}`,
            start: new Date(currentYear, month + 1, 0), // last day of each month
            // let this be red
            color: 'rgba(255, 0, 0, 0.9)',
            display: 'background',
            description: 'This is a cool event',
            allDay: true
        });
    }

    return events;
}

  export function generateCombinedEvents() {
    return [...generateRecurringEvent1(), ...generateRecurringEvent2(), ...generateRecurringEvent3()];
  }

export const INITIAL_EVENTS: EventInput[] = generateCombinedEvents();


export function showEventDescription(arg: any) {
    // show event in a calendar tooltip
    var tooltip = document.createElement('div');
    tooltip.className = 'event-tooltip';
    tooltip.innerHTML = arg.event.extendedProps.description;

    arg.el.appendChild(tooltip);
}

export function hideEventDescription(arg: any) {
    // remove tooltip
    const tooltips = document.querySelectorAll('.event-tooltip');
    tooltips.forEach(tooltip => tooltip.remove());
}